import { Button } from '@mgmresorts/mgm-ui';
import React, { useContext } from 'react';

import { useContent } from '../../../../hooks/useContent';
import { MlifeAccountSetupContext } from '../MlifeAccountSetupContext';

export function CTASection() {
  const { processAccountSetup, isLoading, canProcessAccountSetup } = useContext(MlifeAccountSetupContext);
  const { getContentByPath } = useContent();

  return (
    <Button
      variant='primary'
      size='large'
      label={getContentByPath('mlifeActivation.accountSetupSection.ctaSection.title')}
      testId='mlifeActivation-cta'
      disabled={isLoading || !canProcessAccountSetup}
      onClick={processAccountSetup}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          processAccountSetup();
        }
      }}
      className='identity__form-submit'
      loading={isLoading}
      fullWidth
      type='submit'
    />
  );
}

CTASection.displayName = 'CTASectionField';
